import { makeStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';

const availableStyles = makeStyles(theme => createStyles({
  block: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 12px',
    backgroundColor: theme.palette.colors.lightPrimaryBlue,
    borderRadius: theme.spacing(1),
    minWidth: 230,
    [theme.breakpoints.down('sm')]: {
      minWidth: 'max-content',
    },
  },
  right: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  available: {
    color: theme.palette.primary.dark,
  },
  iconCheck: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.dark,
  },
}));

export default availableStyles;
